/* BiMOR velocita (14/10/2026)
   I caroselli delle card prodotto (.devCardSlider) partono solo quando la card
   arriva vicino allo schermo, invece che tutti insieme al caricamento.
   Le altre chiamate a slick (menu, setPosition, ecc.) restano invariate.
   Per tornare come prima: togliere questo file da layout/theme.liquid. */
(function ($) {
  if (!$ || !$.fn || !$.fn.slick || !('IntersectionObserver' in window)) return;
  var originalSlick = $.fn.slick;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var options = el.__bmSlickOptions;
      delete el.__bmSlickOptions;
      if (!$(el).hasClass('slick-initialized')) originalSlick.call($(el), options);
    });
  }, { rootMargin: '300px 300px' });

  $.fn.slick = function () {
    var args = arguments;
    if (args.length && typeof args[0] === 'object') {
      var cards = this.filter('.devCardSlider');
      if (cards.length) {
        cards.each(function () {
          if ($(this).hasClass('slick-initialized') || this.__bmSlickOptions) return;
          this.__bmSlickOptions = args[0];
          observer.observe(this);
        });
        var others = this.not('.devCardSlider');
        if (others.length) originalSlick.apply(others, args);
        return this;
      }
    }
    return originalSlick.apply(this, args);
  };
})(window.jQuery);
